import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumCheckboxModule } from '@capturum/ui/checkbox';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-formly-checkbox-type',
  imports: [FormsModule, FormlyModule, ReactiveFormsModule, TranslateModule, CapturumCheckboxModule],
  templateUrl: './formly-checkbox-type.component.html',
  styleUrl: './formly-checkbox-type.component.scss',
})
export class FormlyCheckboxTypeComponent extends FieldType {}
